function sanitizeName(str) {
  // Regular expression to match any character that is NOT:
  // - letters (a-z, A-Z)
  // - numbers (0-9)
  // - hyphens (-)
  // - underscores (_)
  const regex = /[^a-zA-Z0-9_-]/g;

  // Replace all non-allowed characters with hyphens
  return str.replace(regex, "-");
}

export default sanitizeName;
